import type { SalonRow } from '@manaro/contracts'
import { buildCsv, csvDate as date, downloadCsv, type CsvColumn } from '@/shared/lib/csv.ts'
import { LOGIN_LABELS, STAGE_LABELS, channelLabel, clientLabel, estimatedClient, planLabel, statusLabel } from './labels.ts'

const COLUMNS: CsvColumn<SalonRow>[] = [
  ['Дата регистрации', (row) => date(row.user.registeredAt)],
  ['Email', (row) => row.user.email],
  ['Имя', (row) => row.user.name ?? ''],
  ['Телефон', (row) => row.user.phone || row.salon?.phone || ''],
  ['Вход', (row) => LOGIN_LABELS[row.user.login]],
  ['Доступ в CRM', (row) => (row.user.crmAccess ? 'да' : 'нет')],
  ['Где зарегистрировался', (row) => (row.user.signup ? clientLabel(row.user.signup.client) : `≈ ${estimatedClient(row.user)}`)],
  ['Канал', (row) => (row.user.signup ? channelLabel(row.user.signup.channel) : '')],
  ['Источник', (row) => row.user.signup?.source ?? ''],
  ['Кампания', (row) => row.user.signup?.campaign ?? ''],
  ['Страница входа', (row) => row.user.signup?.landingPath ?? ''],
  ['ID салона', (row) => row.salon?.id ?? ''],
  ['Салон', (row) => row.salon?.title ?? ''],
  ['Город', (row) => row.salon?.city ?? ''],
  ['Телефоны салона', (row) => (row.salon?.contacts?.phones ?? (row.salon?.phone ? [row.salon.phone] : [])).join(', ')],
  ['Email салона', (row) => row.salon?.contacts?.email ?? ''],
  ['Telegram', (row) => row.salon?.contacts?.telegram ?? ''],
  ['Viber', (row) => row.salon?.contacts?.viber ?? ''],
  ['WhatsApp', (row) => row.salon?.contacts?.whatsapp ?? ''],
  ['Instagram', (row) => row.salon?.contacts?.instagram ?? row.salon?.instagram ?? ''],
  ['Сайт', (row) => row.salon?.contacts?.website ?? ''],
  ['Статус салона', (row) => (row.salon ? statusLabel(row.salon.status) : '')],
  ['Услуг', (row) => row.salon?.services ?? 0],
  ['Мастеров', (row) => row.salon?.masters ?? 0],
  ['Клиентов', (row) => row.salon?.customers ?? 0],
  ['Записей', (row) => row.salon?.orders ?? 0],
  ['Записей за 30 дней', (row) => row.salon?.orders30d ?? 0],
  ['Последняя запись', (row) => date(row.salon?.lastOrderAt ?? null)],
  ['Тариф', (row) => (row.salon?.plan ? planLabel(row.salon.plan) : '')],
  ['Оплат', (row) => row.salon?.payments ?? 0],
  ['Стадия', (row) => STAGE_LABELS[row.stage]],
]

export function downloadSalonsCsv(rows: SalonRow[]): void {
  downloadCsv(`manaro-salons-${new Date().toISOString().slice(0, 10)}.csv`, buildCsv(COLUMNS, rows))
}
